
// Export all API modules
export * from './client';
export * from './contact';
export * from './derivatives';
export * from './channels';
export * from './playlists';
export * from './clips';
export * from './creators';

// Re-export the API instances for easy import
import { contactApi } from './contact';
import { derivativesApi } from './derivatives';
import { channelsApi } from './channels';
import { playlistsApi } from './playlists';
import { clipsApi } from './clips';
import { creatorsApi } from './creators';

// Create a unified API object for convenience
export const api = {
  contact: contactApi,
  derivatives: derivativesApi,
  channels: channelsApi,
  playlists: playlistsApi,
  clips: clipsApi,
  creators: creatorsApi
};
